import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const ArrowRight: React.FC<NormalIconProps> = () => (
	<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Linear / Arrows / Arrow Right">
			<path
				id="Vector"
				d="M3.16663 8H13.8333M13.8333 8L9.83329 4M13.8333 8L9.83329 12"
				stroke="#1A5F56"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
